function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#87BBFD"
}), React.createElement("path", {
  fill: "#555ABF",
  d: "M15.5 4.5H2.63a12 12 0 00-2.36 10H8.5l-1-2a3 3 0 113-3l6 1v-5a1 1 0 00-1-1z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M21.88 9.5H8.5a1 1 0 00-1 1v8a1 1 0 001 1h11.1a1 1 0 00.74-.34 10.96 10.96 0 002.54-8.8 1 1 0 00-1-.86zm-5.38 8a3 3 0 110-6 3 3 0 010 6z"
}))));